/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_PlaceholderInputs */

const en_admin_tickets_reply_placeholder = /** @type {(inputs: Admin_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a reply...`)
};

const zh_admin_tickets_reply_placeholder = /** @type {(inputs: Admin_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入回复内容…`)
};

/**
* | output |
* | --- |
* | "Write a reply..." |
*
* @param {Admin_Tickets_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_placeholder = /** @type {((inputs?: Admin_Tickets_Reply_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_reply_placeholder(inputs)
	return zh_admin_tickets_reply_placeholder(inputs)
});
export { admin_tickets_reply_placeholder as "admin.tickets.reply_placeholder" }